import React from "react";
const ReactComment = () => {
  return /* @__PURE__ */ React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "<!-- [regionalbanner:fragment] -->"
    }
  });
};
const RegionalBannerFragment = () => {
  return /* @__PURE__ */ React.createElement(ReactComment, null);
};
export {
  RegionalBannerFragment
};
